import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouses(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/list_providers/${agro_exporter_id}/fetch_packing_houses`
    );
  },
  fetchOrganizations(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/list_providers/${agro_exporter_id}/fetch_organizations`
    );
  },
  fetchProducers(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/list_providers/${agro_exporter_id}/fetch_producers`
    );
  },
  fetchCertifications(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/list_providers/${agro_exporter_id}/fetch_certifications`
    );
  }
};
